import React, { useEffect, useState } from 'react'
import { Container, FormContainer } from './styled'
import { useParams } from 'react-router-dom'
import InternalHeader from '../../general/internalHeader/view'
import { getEvent} from 'api'
import coworking from 'assets/images/coworking.jpg'
import noAvatar from '../../../../assets/images/no-avatar.png'
import EventForm from '../eventForm/view';

const EventUpdate = () => {

  const params = useParams()
  const { slug } = params
  const [theEvent, setEvent] = useState([])

  
  function getEventInfo() {
    getEvent(slug).then(r => {
      setEvent(r.event)
    })
      .catch(console.error)
  }


  function headerActionMethod() {
  }

  useEffect(() => {
    getEventInfo(true)

  }, [])





  const avatar = noAvatar
  return (
    <Container>
      <InternalHeader title={'New event'} subtitle={''} avatar={avatar} background={coworking} actionTitle='Save event' actionMethod={headerActionMethod} />
      <FormContainer>
        <EventForm event={theEvent}/>
      </FormContainer>
    </Container>
  )
}

EventUpdate.propTypes = {}

export default EventUpdate
